import { apiClient } from "./apiClient";


export const dictionaryApi = {
    getDictionary: () => apiClient.post(`pl_dictionary/select_all`)
}